import { Search } from './lib/search.js';
customElements.define('cipublic-search', Search);
//# sourceMappingURL=cipublic-search.js.map